// @flow

import { type UserInputValidationError } from '@tectonics/prs/validation';
import { type ArgentineDocumentType } from '../types';

export function validateArgentineDocument(document: string, documentType: ArgentineDocumentType): ?UserInputValidationError {
  if (documentType === 'DNI')
    return validateDni(document);
  else
    return validateDocument(document);
  
}

function validateDni(document: string): ?UserInputValidationError {
  if (!document) {
    return { id: 'empty'};
  } else if (!/\d{7,8}/.test(document)) {
    return { id: 'invalid-dni-pattern' };
  }
}

function validateDocument(document: string): ?UserInputValidationError {
  if(( /^0+$/.test(document) || document.length !== 11))
    return { id: 'invalid-argentine-document-pattern' };
}
